import { Card, CardContent, CardHeader, Divider, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { TextField, Grid } from "@mui/material";
import { Colors } from "../../../styles/theme";
import { isValidPhoneNumber } from 'libphonenumber-js';
import { usePreferences } from "hooks/usePreferences";
import { SimplePhoneNumberField } from "../../common/phoneNumberField";

export default function GeneralInfoCard({ formik }) {
    // Get business preferences from the context (pre-loaded, no delay)
    const { preferences: businessPreferences } = usePreferences();

    // Get phone format from preferences or fallback to default
    const phoneFormat = businessPreferences?.phoneNumberFormat || '(###) ###-####';

  return (
    <Card elevation={1}>
      <CardHeader title="General" sx={{ color: Colors.muted }} />
      <Divider />
      <CardContent>
        <Grid container columnSpacing={1}>
          <Grid item xs={12} md={4}>
            <TextField
              required
              name="firstName"
              id="firstName"
              onChange={formik.handleChange}
              value={formik.values.firstName}
              error={formik.touched.firstName && formik.errors.firstName}
              helperText={formik.touched.firstName && formik.errors.firstName}
              label="First name"
              variant="standard"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              name="middleName"
              value={formik.values.middleName}
              onChange={formik.handleChange}
              id="pr-middle-name"
              label="Middle name"
              variant="standard"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              required
              name="lastName"
              id="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              error={formik.touched.lastName && formik.errors.lastName}
              helperText={formik.touched.lastName && formik.errors.lastName}
              label="Last name"
              variant="standard"
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container columnSpacing={1} alignItems="center" mt={4}>
          <Grid item xs={12} md={4}>
            <SimplePhoneNumberField
              formik={formik}
              fieldName="mobile"
              mask={phoneFormat}
              countryCode={businessPreferences?.countryCode || '+1'}
              required
              label="Mobile"
              variant="standard"
              fullWidth
              error={
                formik.touched.mobile &&
                !isValidPhoneNumber(formik.values.mobile, "US")
              }
              helperText={
                formik.touched.mobile &&
                !isValidPhoneNumber(formik.values.mobile, "US") &&
                "Invalid phone"
              }
              id="mobile"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SimplePhoneNumberField
              formik={formik}
              fieldName="home"
              mask={phoneFormat}
              countryCode={businessPreferences?.phoneNumberCountryCode || '+1'}
              label="Home"
              variant="standard"
              fullWidth
              id="pr-home"
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <SimplePhoneNumberField
              formik={formik}
              fieldName="work"
              mask={phoneFormat}
              countryCode={businessPreferences?.phoneNumberCountryCode || '+1'}
              label="Work"
              variant="standard"
              fullWidth
              id="pr-work"
            />
          </Grid>
        </Grid>
        <FormControl sx={{ mt: 4 }}>
          <FormLabel id="sex" sx={{ display: 'flex' }}>Gender</FormLabel>
          <RadioGroup
            name="sex"
            error={
              formik.touched.sex && Boolean(formik.errors.sex)
            }
            value={formik.values.sex}
            onChange={formik.handleChange}
            row
          >
            <FormControlLabel
              value="female"
              control={<Radio size="small" />}
              label="Female"
            />
            <FormControlLabel
              value="male"
              control={<Radio size="small" />}
              label="Male"
            />
            <FormControlLabel
              value="other"
              control={<Radio size="small" />}
              label="Other"
            />
          </RadioGroup>
        </FormControl>
      </CardContent>
    </Card>
  );
}